"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.statusMessages = exports.subjectMessages = exports.Status = exports.Subject = void 0;
const schema_1 = require("../../schema");
var Subject;
(function (Subject) {
    Subject["COMMITTEE_MEETING_OPINION"] = "COMMITTEE_MEETING_OPINION";
    Subject["OUTSIDE_COMMITTEE_OPINION"] = "OUTSIDE_COMMITTEE_OPINION";
    Subject["MEDICAL_PRACTITIONER_COMMENT"] = "MEDICAL_PRACTITIONER_COMMENT";
    Subject["PATIENT_INFO"] = "PATIENT_INFO";
})(Subject || (exports.Subject = Subject = {}));
var Status;
(function (Status) {
    Status["NEW"] = "NEW";
    Status["COMMITTEE_OPINION"] = "COMMITTEE_OPINION";
    Status["READY_FOR_COMMITTEE"] = "READY_FOR_COMMITTEE";
    Status["WAITING_FOR_MEDICAL_EXAMINATION"] = "WAITING_FOR_MEDICAL_EXAMINATION";
    Status["TRANSPLANTABLE"] = "TRANSPLANTABLE";
    Status["NON_TRANSPLANTABLE"] = "NON_TRANSPLANTABLE";
    Status["SUITABLE"] = "SUITABLE";
    Status["UNSUITABLE"] = "UNSUITABLE";
    Status["KTX_DONE"] = "KTX_DONE";
    Status["EXIT"] = "EXIT";
})(Status || (exports.Status = Status = {}));
exports.subjectMessages = {
    [Subject.COMMITTEE_MEETING_OPINION]: {
        id: "ktx.committeeOpinion.subject.COMMITTEE_MEETING_OPINION",
        defaultMessage: "Bizottsági ülés jegyzőkönyve"
    },
    [Subject.OUTSIDE_COMMITTEE_OPINION]: {
        id: "ktx.committeeOpinion.subject.OUTSIDE_COMMITTEE_OPINION",
        defaultMessage: "Bizottság ülésen kívüli megjegyzése"
    },
    [Subject.MEDICAL_PRACTITIONER_COMMENT]: {
        id: "ktx.committeeOpinion.subject.MEDICAL_PRACTITIONER_COMMENT",
        defaultMessage: "Kezelőorvos megjegyzése"
    },
    [Subject.PATIENT_INFO]: {
        id: "ktx.committeeOpinion.subject.PATIENT_INFO",
        defaultMessage: "Beteg által közölt információ"
    }
};
exports.statusMessages = {
    [Status.NEW]: {
        id: "ktx.committeeOpinion.status.NEW",
        defaultMessage: "Új"
    },
    [Status.COMMITTEE_OPINION]: {
        id: "ktx.committeeOpinion.status.COMMITTEE_OPINION",
        defaultMessage: "Bizottsági véleményezésre kiküldve"
    },
    [Status.READY_FOR_COMMITTEE]: {
        id: "ktx.committeeOpinion.status.READY_FOR_COMMITTEE",
        defaultMessage: "Bizottsági Referálásra Kész"
    },
    [Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "ktx.committeeOpinion.status.WAITING_FOR_MEDICAL_EXAMINATION",
        defaultMessage: "Kiegészítő Vizsgálatra Vár"
    },
    [Status.TRANSPLANTABLE]: {
        id: "ktx.committeeOpinion.status.TRANSPLANTABLE",
        defaultMessage: "Transzplantálható"
    },
    [Status.NON_TRANSPLANTABLE]: {
        id: "ktx.committeeOpinion.status.NON_TRANSPLANTABLE",
        defaultMessage: "Nem Transzplantálható"
    },
    [Status.SUITABLE]: {
        id: "ktx.committeeOpinion.status.SUITABLE",
        defaultMessage: "Alkalmas"
    },
    [Status.UNSUITABLE]: {
        id: "ktx.committeeOpinion.status.UNSUITABLE",
        defaultMessage: "Alkalmatlan"
    },
    [Status.KTX_DONE]: {
        id: "ktx.committeeOpinion.status.KTX_DONE",
        defaultMessage: "KTX megtörtént"
    },
    [Status.EXIT]: {
        id: "ktx.committeeOpinion.status.EXIT",
        defaultMessage: "Exit"
    }
};
const subject = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Subject.COMMITTEE_MEETING_OPINION),
    schema_1.Schema.singleChoiceItem(Subject.OUTSIDE_COMMITTEE_OPINION),
    schema_1.Schema.singleChoiceItem(Subject.MEDICAL_PRACTITIONER_COMMENT),
    schema_1.Schema.singleChoiceItem(Subject.PATIENT_INFO)
]);
const description = schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "description_of_patient_condition" });
const status = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Status.NEW),
    schema_1.Schema.singleChoiceItem(Status.COMMITTEE_OPINION),
    schema_1.Schema.singleChoiceItem(Status.READY_FOR_COMMITTEE),
    schema_1.Schema.singleChoiceItem(Status.WAITING_FOR_MEDICAL_EXAMINATION),
    schema_1.Schema.singleChoiceItem(Status.TRANSPLANTABLE),
    schema_1.Schema.singleChoiceItem(Status.NON_TRANSPLANTABLE),
    schema_1.Schema.singleChoiceItem(Status.SUITABLE),
    schema_1.Schema.singleChoiceItem(Status.UNSUITABLE),
    schema_1.Schema.singleChoiceItem(Status.KTX_DONE),
    schema_1.Schema.singleChoiceItem(Status.EXIT)
])
    .interpretation({ vocab: "ktx", code: "patient_status" })
    .tag({ vocab: "snomed", code: "224238005" });
const assignedUser = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../status} === "COMMITTEE_OPINION"`), schema_1.Schema.remoteSelect("$users").interpretation({
    vocab: "ktx",
    code: "patient_assigned_user"
}));
const missingForms = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../status} === "WAITING_FOR_MEDICAL_EXAMINATION"`), schema_1.Schema.remoteMultiSelect("$forms"));
const neakCheck = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../status} === "TRANSPLANTABLE" || {../status} === "NON_TRANSPLANTABLE"`), schema_1.Schema.boolean().optional());
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    subject,
    description,
    status,
    assignedUser,
    missingForms,
    neakCheck
})
    .interpretation({ vocab: "ktx", code: "committee_opinion_statement" });
